export default __webpack_public_path__ + "static/media/extensions.151d579d.svg";